var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.fade ? 'BaseTransitionOpacity' : 'div',{tag:"component"},[(_vm.visible)?_c('div',{ref:"overlayEl",staticClass:"backdrop-overlay fixed inset-0",class:[_vm.zIndex]}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }